import { RecentRound } from '../models/recent-round';

class RecentRoundsService {
    public getRecentRounds() {
        const data = localStorage.getItem('recentRounds');
        if (!data) return [];
        const recentRounds = JSON.parse(data) as RecentRound[];
        return recentRounds.filter((r) => {
            if (!r.expiresAt) return true;
            const expireDate = new Date(r.expiresAt);
            return expireDate > new Date();
        });
    }

    public markRoundsPermanent(roundIds: string[]) {
        const roundIdSet = new Set(roundIds);
        const existing = this.getRecentRounds();
        const updated = existing.map((r) => (roundIdSet.has(r.roundId) ? { ...r, expiresAt: undefined } : r));
        localStorage.setItem('recentRounds', JSON.stringify(updated));
    }

    public updateRecentRounds(
        roundId: string,
        roundName: string,
        roundDate: string,
        playerId: string,
        playerName: string,
        expiresAt?: string
    ) {
        const recentRound = {
            roundId,
            roundName,
            roundDate,
            playerId,
            playerName,
            expiresAt,
        };
        const existing = this.getRecentRounds();
        const filtered = existing.filter((r) => r.roundId !== roundId);
        const updated = [recentRound, ...filtered].slice(0, 10);
        localStorage.setItem('recentRounds', JSON.stringify(updated));
    }
}

export const recentRoundsService = new RecentRoundsService();
